import {faker}  from "@faker-js/faker";
import { regions } from "./regions";
import { getOrgApp } from "../helpers/get-orgApp";

export const allWorkspaces = async (count) => {
  const mappedWorkspaces = await Promise.all(
    [...Array(count)].map(async () => {
      const workspace = await addWorkspace();
      return workspace;
    })
  );

  return mappedWorkspaces;
};

const addWorkspace = async () => {
  const regionCodes = regions.map((reg) => reg.RegionCode);
  const _regionCode = faker.helpers.arrayElement(regionCodes);
  let orgAppDetails = await getOrgApp();
  let selectedOrg = faker.helpers.arrayElement(orgAppDetails);
  let selectedDept = faker.helpers.arrayElement(selectedOrg.depts);
  let selectedDeptApp = faker.helpers.arrayElement(selectedDept.deptApps);
  let selectedDeptAccount = faker.helpers.arrayElement(
    selectedDept.deptAccounts
  );
  const _accountNumber = selectedDeptAccount.accountNumber;

  return {
    AccountNumber: _accountNumber,
    Apps: selectedDeptApp ? [selectedDeptApp.appId] : [],
    RegionCode: _regionCode,
    WorkspaceId: `ws-${faker.random.alphaNumeric(10)}`,
    State: faker.helpers.arrayElement(["AVAILABLE"]),
    UserName: faker.internet.userName().toLowerCase(),
    ComputerName: "A-VALIZTE4513KD",
    BundleId: `wsb-${faker.random.alphaNumeric(10)}`,
    SubnetId: `subnet-${faker.random.alphaNumeric(10)}`,
    DirectoryId: `d-${faker.random.alphaNumeric(10)}`,
    IpAddress: faker.internet.ip(),
    WorkspaceProperties: {
      RunningMode: faker.helpers.arrayElement(["AUTO_STOP", "ALWAYS_ON"]),
      ComputeTypeName: "STANDARD",
      RootVolumeSizeGib: 80,
      RunningModeAutoStopTimeoutInMinutes: 60,
      UserVolumeSizeGib: 50,
    },
  };
};
